/**
 * Public address for legal and privacy questions.
 * Change it here only — the site reads this constant everywhere it is shown.
 */
export const PUBLIC_CONTACT_EMAIL = "avivhdr@gmail.com";

export function legalContactParagraph(kind: "terms" | "privacy"): string {
  if (kind === "terms") {
    return `Questions about these terms: email ${PUBLIC_CONTACT_EMAIL}. You can also open an issue at github.com/Avivhdr/JuDI.`;
  }
  return `Privacy questions: email ${PUBLIC_CONTACT_EMAIL}. You can also delete your account from Settings, or open an issue at github.com/Avivhdr/JuDI.`;
}
